
import { Component, Vue, Watch, Ref } from 'vue-property-decorator'
import HeaderUser from './Header.User.vue'
import HeaderNotify from './Header.Notify.vue'
import Notification from './notify/Notification.vue'
import { useAppStore } from '@/store/app'
import { useUserStore } from '@/store/user'
import { useUpdateStore } from '@/store/update'
import { useMenuStore } from '@/store/menu'
import config from '@/config'
import { Modal } from 'ant-design-vue'
import { SysPopMessageDto } from '@/api/swagger'
import pinia from '@/store'
import UserCompareInfoModal from '@/layout/main/components/UserCompareInfoModal.vue'
import { useClientStore, ClientType } from '@/store/client'
import { useReuseTabStore } from '@/store/reuse-tab'
import DailyExamModal from './DailyExamModal.vue'
import MonthlyExamModal from './MonthlyExamModal.vue'

// 弹窗消息公告类型
export enum PopMessageNoticeType {
  // 更新
  Update = 1,
  // 公告
  Public,
}

@Component({
  components: {
    HeaderUser,
    HeaderNotify,
    Notification,
    UserCompareInfoModal,
    DailyExamModal,
    MonthlyExamModal,
  },
})
export default class AdminHeader extends Vue {
  @Ref('userCompareInfoModal')
  private refUserCompareInfoModal!: UserCompareInfoModal
  @Ref('dailyExamModal')
  private refDailyExamModal!: DailyExamModal
  @Ref('monthlyExamModalRef')
  private monthlyExamModalRef!: MonthlyExamModal

  private appStore = useAppStore(pinia)
  public isTest = false
  public officeHallUrl = '/hall'
  public administration = false
  public updateStore = useUpdateStore(pinia)
  private get appName() {
    return config.get('NAME')
  }
  private userStore = useUserStore(pinia)
  private menuStore = useMenuStore(pinia)
  private reuseTabStore = useReuseTabStore(pinia)
  private popMsgList: SysPopMessageDto[] = []
  private pendingMonthExamId = ''

  private clientStore = useClientStore(pinia)
  private clientTypeEnum = ClientType

  private get canSwitchClient() {
    return (
      this.clientStore.clients.includes(ClientType.Web) &&
      this.clientStore.clients.includes(ClientType.ElectricVehicleInspection)
    )
  }

  private get switchToClientTitle() {
    return this.clientStore.currentClient === ClientType.Web
      ? '切换至广西壮族自治区电动自行车安全隐患全链条整治平台'
      : '切换至广西建设工程消防设计审查验收备案管理平台'
  }

  private get isBlackRoute() {
    return [
      this.$route.path.startsWith('/workbench'),
      this.$route.path.startsWith('/hall'),
      this.$route.path === '/',
    ].includes(true)
  }

  @Watch('userStore.info.id')
  private userIdChange() {
    this.handlerFirstEnter()
  }

  @Watch('$route')
  private async changeWatch(newVal, oldVal) {
    if (newVal.path !== '/' && oldVal.path === '/') {
      this.handlerFirstEnter()
    }

    if (newVal.fullPath === '/fire/home') {
      // const [monthExamId, hasDailyExam] = await Promise.all([
      //   this.checkAndCreateMonthExam(),
      //   this.refDailyExamModal.checkAndShow(),
      // ])
      // this.pendingMonthExamId = monthExamId
      // if (!hasDailyExam) {
      //   this.showMonthExamModal()
      // }
      const hasDailyExam = await this.refDailyExamModal.checkAndShow()
      if (!hasDailyExam) {
        const monthExamId = await this.checkAndCreateMonthExam()
        this.pendingMonthExamId = monthExamId
        this.showMonthExamModal()
      }
    }
  }

  private created() {
    console.log(55)
    this.$nextTick(() => {
      // this.personnelTableRef.refresh()
    })
  }

  private isFirstEnterFire = true
  private async handlerFirstEnter() {
    if (!this.isFirstEnterFire) return
    if (this.userStore.info.id && !this.isBlackRoute) {
      this.isFirstEnterFire = true
      this.getPopMessage()

      this.getCompareInfo()
      if (
        this.userStore.info.roles?.some((item) => item.code === 'FireInspectorsOrgManager') &&
        this.userStore.info.isStopCode
      ) {
        this.stopCodeUndoneProgrammeWarn()
      }

      if (this.userStore.info.roles?.some((item) => item.code === 'FireInspectorsOrgManager')) {
        this.checkTestDeviceOverdue()
      }
      this.refDailyExamModal.checkAndShow()

      // const [monthExamId, hasDailyExam] = await Promise.all([
      //   this.checkAndCreateMonthExam(),
      //   this.refDailyExamModal.checkAndShow(),
      // ])
      // this.pendingMonthExamId = monthExamId
      // if (!hasDailyExam) {
      //   this.showMonthExamModal()
      // }
    }
  }

  private checkAndCreateMonthExam() {
    return this.$examHttp
      .get('/api/ksexamination/checkandcreatemonthexam')
      .then((res) => res?.data || '')
      .catch((err) => {
        this.$message.error(err.message || '获取失败')
        return ''
      })
  }

  private async handleDailyExamSuccess() {
    // this.showMonthExamModal()
    const monthExamId = await this.checkAndCreateMonthExam()
    this.pendingMonthExamId = monthExamId
    this.showMonthExamModal()
  }

  private showMonthExamModal() {
    const examId = this.pendingMonthExamId
    if (!examId) return
    this.pendingMonthExamId = ''

    this.monthlyExamModalRef.init({ examId, visible: true })
  }

  private getPopMessage() {
    this.$http.get('/api/SysPopMessage/GetPopMessage', {}).then((res) => {
      this.popMsgList = res.data || []
      const cacheName = `popMsgCacheList_${this.userStore.userInfo.id}`
      // 是超级管理员
      const isSuperManager = this.userStore.userInfo.roles?.some((item) => item.code === 'SuperManager') || false
      let cacheList: string[] = localStorage.getItem(cacheName)?.split(',') || []
      const msgList = res.data.filter((item) => (item.isOnlyOnce ? !cacheList?.includes(String(item.id)) : true))
      if (msgList.length) {
        let i = 0
        while (i < msgList.length) {
          const item = msgList[i]
          Modal.info({
            title: item.title,
            cancelButtonProps: {
              style: 'display: none',
            },
            width: '1000px',
            zIndex: 2000,
            okButtonProps: {
              style: `display: ${item.isCanShutDown || isSuperManager ? 'block' : 'none'}`,
            },
            onOk: () => {
              document.body.style.overflow = 'auto'
            },
            content: (h) =>
              h('div', {
                domProps: {
                  innerHTML: item.content,
                },
              }),
            keyboard: item.isCanShutDown,
          })
          if (item.isOnlyOnce && item.id && !cacheList.includes(item.id)) {
            cacheList.push(item.id)
          }
          i++
        }
        localStorage.setItem(cacheName, cacheList.join(','))
      }
    })
  }

  public handlerCollapsedSidebar() {
    this.appStore.collapse()
  }
  public toHall() {
    this.$router.push({
      path: '/hall',
    })
  }
  public toHelp() {
    window.open('/helpcenter/help', '_blank')
  }
  private showUpdateInfo() {
    const data = this.popMsgList.filter((item) => item.noticeType === PopMessageNoticeType.Update)?.[0]
    if (data) {
      Modal.info({
        title: data.title,
        cancelButtonProps: {
          style: 'display: none',
        },
        width: '1000px',
        onOk: () => {
          document.body.style.overflow = 'auto'
        },
        content: (h) =>
          h('div', {
            domProps: {
              innerHTML: data.content,
            },
          }),
        keyboard: data.isCanShutDown,
      })
    } else {
      this.$message.info('无更新记录')
    }
  }

  private getCompareInfo() {
    this.$http
      .get('/api/UserInfo/GetCompareInfo', {})
      .then((res) => {
        if (!res.data) return
        this.$notification.info({
          message: '区统一认证平台信息更新',
          description: '当前账户信息与区统一认证平台信息存在差异，是否将最新账户信息更新至本平台？',
          duration: 0,
          key: 'notifyCompareInfo',
          top: '50px',
          btn: (h) =>
            h('div', [
              h(
                'a-button',
                {
                  on: {
                    click: () => this.showUserCompareInfoModal(res.data),
                  },
                },
                '对比信息差异',
              ),
              h(
                'a-button',
                {
                  style: { marginLeft: '8px' },
                  props: {
                    type: 'primary',
                  },
                  on: {
                    click: () => this.confirmSyncInfo(),
                  },
                },
                '同步更新',
              ),
            ]),
        })
      })
      .catch((err) => {
        // this.$message.error(err.massage || '政务一体化平台信息对比失败！')
      })
  }
  private showUserCompareInfoModal(data) {
    this.refUserCompareInfoModal.show(data)
  }
  private confirmSyncInfo() {
    this.$http
      .get('/api/UserInfo/UpdateCompareInfo', {})
      .then(() => {
        this.$message.success('账户数据同步更新成功！')
        this.$notification.close('notifyCompareInfo')
      })
      .catch((err) => {
        this.$message.error(err.message || '账户数据同步更新失败！')
      })
  }

  /**
   * 查验单位停码后存在未完成方案提醒
   */
  private stopCodeUndoneProgrammeWarn() {
    this.$http
      .get('/api/TestModule/TestProgramme/WarningStopCodeCompany')
      .then((res) => {
        const message = (res as any).data
        message &&
          this.$notification.warning({
            message: '停码提醒',
            description: message,
            duration: 0,
            top: '50px',
          })
      })
      .catch((err) => {
        console.error(err.message || '停码单位存在未完成方案提醒失败')
      })
  }

  private checkTestDeviceOverdue() {
    this.$http
      .get('/api/TestModule/TestDevice/GetDueDevice')
      .then((res) => {
        const haveOverdueDevice = res.data.length > 0
        if (!haveOverdueDevice) return
        this.$confirm({
          icon: (h) => h('a-icon', { props: { type: 'info-circle' } }),
          title: '设备即将过期提醒',
          content: (h) => h('p', '您单位下有设备即将过期，请及时校准并更新设备信息'),
          okText: '去更新',
          cancelText: '知道了',
          onOk() {
            window.history.pushState(null, '', '/fire/testing-management/equipment')
          },
        })
      })
      .catch((err) => {
        this.$message.error(err.message || '设备到期提醒失败')
      })
  }

  private changeToClient(value: ClientType) {
    this.clientStore.changeToClient(value).then(() => {
      this.reuseTabStore.clear()
      window.history.pushState(null, '', '/fire/home')
    })
  }
  private switchClient() {
    this.clientStore.currentClient === ClientType.ElectricVehicleInspection
      ? this.changeToClient(ClientType.Web)
      : this.changeToClient(ClientType.ElectricVehicleInspection)
  }
}
